import React, { createContext, useState } from "react";
import { RoutesType } from "../types/routes";

interface Props {
    children: React.ReactNode
}

export interface IRoutesContext {
    routes: RoutesType | null;
    setRoutes: React.Dispatch<React.SetStateAction<RoutesType | null>>
}

export const RoutesContext = createContext<null | IRoutesContext>(null);

export const RoutesProvider: React.FC<Props> = ({ children }) => {  
    const [routes, setRoutes] = useState<RoutesType | null>(null);    
    
    const value: IRoutesContext = {
        routes,
        setRoutes
    };

    return (
        <RoutesContext.Provider
            value={value}
        >
            {children}
        </RoutesContext.Provider>
    );
};